<script lang="ts" setup>
import type { ProductDetailItem } from "~~/models/products";
import { onWatcherCleanup } from "vue";

defineProps<{ product: ProductDetailItem; thumbSwiperId: string }>();

const emit = defineEmits<{
  mainImageClick: [activeIdx: number];
}>();

const activeIdx = ref(0);

// @ts-expect-error swiperEl is known and unclear why TS build is showing an error
const { swiperEl } = useSwiper();

watch(swiperEl, () => {
  const handleSwiperSlideChange = (event: any) => {
    activeIdx.value = event.detail.at(0)?.activeIndex ?? 0;
  };

  swiperEl.value.addEventListener("swiperslidechange", handleSwiperSlideChange);

  onWatcherCleanup(() => {
    swiperEl.value.removeEventListener("swiperslidechange", handleSwiperSlideChange);
  });
});
</script>

<template>
  <div class="gap-md mx-auto flex w-full flex-col sm:w-[350px] lg:w-[545px]">
    <div>
      <swiper-container
        :navigation="false"
        :loop="true"
        :thumbs-swiper="`.${thumbSwiperId}`"
      >
        <swiper-slide v-for="(image, mainIdx) in product.sortedImages" :key="mainIdx" :data-slide-index="mainIdx" class="flex">
          <div class="flex size-[350px] items-center justify-center lg:size-[545px]" @click="emit('mainImageClick', activeIdx)">
            <NuxtImg
              provider="bunny"
              placeholder="/img/placeholder.svg"
              :src="image.relativeUrl"
              :alt="product.name ?? ''"
              :title="product.name ?? ''"
              class="h-[260px] object-cover lg:h-[400px]"
            />
          </div>
        </swiper-slide>
      </swiper-container>
    </div>

    <div class="px-xl">
      <swiper-container
        class="h-full"
        :class="thumbSwiperId"
        :slides-per-view="4"
        :space-between="8"
        :navigation="true"
        :loop="true"
      >
        <swiper-slide v-for="(image, thumbIdx) in product.sortedImages" :key="thumbIdx" :data-slide-index="thumbIdx" class="flex">
          <div
            class=" flex size-[65px] items-center justify-center rounded-lg lg:size-[100px]"
            :class="{ 'border-primary-200 border': activeIdx === thumbIdx }"
          >
            <NuxtImg
              provider="bunny"
              placeholder="/img/placeholder.svg"
              :src="image.relativeUrl"
              :alt="product.name ?? ''"
              :title="product.name ?? ''"
              class="h-[40px] object-cover lg:h-[75px]"
            />
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
</template>

<style scoped>

</style>
